import { type AllocationFragment, type AmountFragment } from "src/graphql/generated/types";

import { formatAmountCSV } from "../amount";
import { formatDate } from "../dates";

type Data = {
  allocations: Array<AllocationFragment>;
  totalToAllocate: AmountFragment;
  totalVat: AmountFragment;
  totalRecoverable: AmountFragment;
};

export const generateExpenseTypesCSV = (data: Data) => {
  const { allocations, totalToAllocate, totalVat, totalRecoverable } = data;

  let csvContent = "CLE DE REPARTITION;TYPE DE CHARGE;A REPARTIR;TVA;RECUPERABLE\n";

  allocations.forEach((allocation) => {
    allocation.expenseTypes.forEach((expenseType) => {
      const allocationName = `${allocation.code} - ${allocation.name}`.replace(/;/g, "");
      const expenseTypeName = `${expenseType.code} - ${expenseType.name}`.replace(/;/g, "");

      csvContent += `${allocationName};${expenseTypeName};${formatAmountCSV(
        expenseType.toAllocate
      )};${formatAmountCSV(expenseType.vat)};${formatAmountCSV(expenseType.recoverable)}\n`;
    });
  });

  csvContent += `TOTAUX;;${formatAmountCSV(totalToAllocate)};${formatAmountCSV(
    totalVat
  )};${formatAmountCSV(totalRecoverable)}\n`;

  return csvContent;
};

export const generateExpensesCSV = (data: Data) => {
  const { allocations, totalToAllocate, totalVat, totalRecoverable } = data;

  let csvContent = "DATE;CLE DE REPARTITION;TYPE DE CHARGE;LIBELLE;A REPARTIR;TVA;RECUPERABLE\n";

  allocations.forEach((allocation) => {
    allocation.expenseTypes.forEach((expenseType) => {
      expenseType.expenses.forEach((expense) => {
        const date = formatDate(expense.date);
        const allocationName = `${allocation.code} - ${allocation.name}`.replace(/;/g, "");
        const expenseTypeName = `${expenseType.code} - ${expenseType.name}`.replace(/;/g, "");
        const label = expense.label.replace(/;/g, "").toUpperCase();

        csvContent += `${date};${allocationName};${expenseTypeName};${label};${formatAmountCSV(
          expense.toAllocate
        )};${formatAmountCSV(expense.vat)};${formatAmountCSV(expense.recoverable)}\n`;
      });
    });
  });

  csvContent += `TOTAUX;;;;${formatAmountCSV(totalToAllocate)};${formatAmountCSV(
    totalVat
  )};${formatAmountCSV(totalRecoverable)}\n`;

  return csvContent;
};
